import React from "react";
import ReactDOM from "react-dom/client";
import { createBrowserRouter, RouterProvider, Navigate } from "react-router-dom";

// Self-hosted fonts (needed so COEP: require-corp doesn't block Google Fonts)
import "@fontsource/space-grotesk/400.css";
import "@fontsource/space-grotesk/500.css";
import "@fontsource/space-grotesk/600.css";
import "@fontsource/space-grotesk/700.css";
import "@fontsource/jetbrains-mono/400.css";

import "./index.css";
import Record from "./pages/Record";
import AdminLogin from "./pages/AdminLogin";
import Admin from "./pages/Admin";
import AdminCrmLayout from "./pages/AdminCrmLayout";
import AdminVideo from "./pages/AdminVideo";
import BestOf from "./pages/BestOf";
import CrmLeadDetail from "./pages/crm/CrmLeadDetail";
import CrmLeadsList from "./pages/crm/CrmLeadsList";
import CrmSectionPlaceholder from "./pages/crm/CrmSectionPlaceholder";
import CrmToday from "./pages/crm/CrmToday";
import CrmTraces from "./pages/crm/CrmTraces";
import Home from "./pages/Home";
import AvatarBuilder from "./pages/AvatarBuilder";
import AvatarSessionShare from "./pages/AvatarSessionShare";

const router = createBrowserRouter([
  { path: "/", element: <Home /> },
  { path: "/r/:linkId", element: <Record /> },
  { path: "/best-of", element: <BestOf /> },
  { path: "/builder", element: <AvatarBuilder /> },
  { path: "/avatar/sessions/:sessionId/share", element: <AvatarSessionShare /> },
  { path: "/admin", element: <Admin /> },
  { path: "/admin/login", element: <AdminLogin /> },
  {
    path: "/admin/crm",
    element: <AdminCrmLayout />,
    children: [
      { index: true, element: <CrmToday /> },
      {
        path: "estrellas",
        element: (
          <CrmSectionPlaceholder
            title="Estrellas"
            description="Vue prioritaire des contacts chauds — données Dynamo à modéliser (prochain sprint)."
          />
        ),
      },
      {
        path: "touchpoints",
        element: (
          <CrmSectionPlaceholder
            title="Touchpoints"
            description="Historique des interactions — à brancher sur les entités touchpoint."
          />
        ),
      },
      {
        path: "batches",
        element: (
          <CrmSectionPlaceholder
            title="Batches"
            description="Préparation et envoi de newsletters / lots — à venir."
          />
        ),
      },
      { path: "leads", element: <CrmLeadsList /> },
      { path: "leads/:leadId", element: <CrmLeadDetail /> },
      { path: "traces", element: <CrmTraces /> },
      {
        path: "suggestions",
        element: (
          <CrmSectionPlaceholder
            title="Suggestions"
            description="Enrichissement (ex. Gmail) — hors scope du sprint actuel."
          />
        ),
      },
      {
        path: "exited",
        element: (
          <CrmSectionPlaceholder
            title="Sortis"
            description="Contacts sortis du pipeline — à venir."
          />
        ),
      },
      {
        path: "settings",
        element: (
          <CrmSectionPlaceholder
            title="Réglages"
            description="Préférences CRM — à venir."
          />
        ),
      },
    ],
  },
  // Legacy redirect for old AdminList path
  { path: "/admin/videos", element: <Navigate to="/admin#videos" replace /> },
  { path: "/admin/videos/:videoId", element: <AdminVideo /> },
]);

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);
